export const colors = [
    { color: 'b50101', key : 1},
    { color: '01b538', key : 2},
    { color: '0184b5', key : 3},
    { color: '012bb5', key : 4},
    { color: 'cccccc', key : 5},
    { color: 'a601b5', key : 6},
    { color: 'e09815', key : 7},
    { color: '000000', key : 8},
    { color: '2980B9', key : 9},
    { color: '17A589', key : 10},
    { color: '229954', key : 11},
    { color: 'D4AC0D', key : 12},
    { color: 'D68910', key : 13},
    { color: 'BA4A00', key : 14},
    { color: '909497', key : 15},
    { color: '283747', key : 16}
];



// WEBPACK FOOTER //
// ./src/components/PricingValueComponent/constants.js